class MegaMenu extends HTMLElement {
  constructor() {
    super();
    let menuLinks = document.querySelectorAll('.header__inline-menu details');
    let subMenus = document.querySelectorAll('.header__inline-menu .header__submenu');
    let dontCloseIfFocusedClasses = ['header__submenu', 'menu-column'];

    let maybeCloseMenu = function(e, i) {
      if(e.relatedTarget) {
        let keepMenuOpen = false;
        for(let j = 0; j < dontCloseIfFocusedClasses.length; j++){
          const targetClasses = e.relatedTarget.className;
          if(targetClasses === "" && targetClasses.includes(dontCloseIfFocusedClasses[i])){
            keepMenuOpen = true;
            break;
          }
        }
        if(!keepMenuOpen) {
          menuLinks[i].removeAttribute('open');
        }
      }
    }
    if (menuLinks.length > 0 && subMenus.length > 0) {
      for(let i = 0; i < menuLinks.length; i++) {
        menuLinks[i].addEventListener('mouseover', function(e){
          menuLinks[i].setAttribute('open', '');
        });
        menuLinks[i].addEventListener('mouseout', function(e){
          maybeCloseMenu(e,i);
        });
      }
    }
  }
}

customElements.define('mega-menu', MegaMenu);